import { format } from 'date-fns';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { CalendarRangeIcon } from '@air/design-icons';
import { MONTH_DAY_YEAR_FORMAT, parseAirDateToISO } from '@air/utilities';

import { InfoPanelDetailsSection } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection';
import { InfoPanelDetailValue } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue';
import { centralizedClipRecordedAtSelector } from '~/store/centralizedClip/selectors';

export const InfoPanelDateCreated = memo(() => {
  const recordedAt = useSelector(centralizedClipRecordedAtSelector);

  const formattedCreatedAt = format(parseAirDateToISO(recordedAt), MONTH_DAY_YEAR_FORMAT);

  if (!formattedCreatedAt) {
    return null;
  }

  return (
    <InfoPanelDetailsSection Icon={CalendarRangeIcon} title="Date Created">
      <InfoPanelDetailValue value={formattedCreatedAt} />
    </InfoPanelDetailsSection>
  );
});

InfoPanelDateCreated.displayName = 'InfoPanelDateCreated';
